
import used from '../assest/products/extra/used.png'
import refurbished from '../assest/products/extra/refurbished.png'
import { useState, useRef } from "react";

const CompareSlider = () => {
  const [position, setPosition] = useState(50);
  const containerRef = useRef(null);
  const dragging = useRef(false);

  const updatePosition = (clientX) => {
    const rect = containerRef.current.getBoundingClientRect();
    let x = clientX - rect.left;
    let percent = (x / rect.width) * 100;

    if (percent < 0) percent = 0;
    if (percent > 100) percent = 100;

    setPosition(percent);
  };

  return (
    <div
      ref={containerRef}
      className="relative w-full max-w-5xl mx-auto mt-10 select-none"
      onMouseMove={(e) => dragging.current && updatePosition(e.clientX)}
      onMouseUp={() => (dragging.current = false)}
      onMouseLeave={() => (dragging.current = false)}
      onTouchMove={(e) => updatePosition(e.touches[0].clientX)}
    >

      <div className="relative h-[260px] sm:h-[420px] lg:h-[560px] overflow-hidden bg-black">

        {/* BASE IMAGE */}
        <img
          src={used}
          draggable="false"
          onDragStart={(e) => e.preventDefault()}
          className="absolute inset-0 w-full h-full object-contain"
        />

        {/* OVERLAY IMAGE */}
        <img
          src={refurbished}
          draggable="false"
          onDragStart={(e) => e.preventDefault()}
          className="absolute inset-0 w-full h-full object-contain"
          style={{
            clipPath: `inset(0 ${100 - position}% 0 0)`
          }}
        />

        {/* SLIDER LINE */}
        <div
          className="absolute top-0 bottom-0 w-[2px] bg-white z-20"
          style={{ left: `${position}%` }}
        />

        {/* HANDLE */}
        <div
          onMouseDown={() => (dragging.current = true)}
          onTouchStart={(e) => updatePosition(e.touches[0].clientX)}
          className="absolute z-30 top-1/2 -translate-y-1/2 -translate-x-1/2 cursor-pointer"
          style={{ left: `${position}%` }}
        >
          <div className="w-12 h-12 bg-white rounded-full shadow-xl flex items-center justify-center border">
            ⇆
          </div>
        </div>

        {/* LABELS */}
        {/* <div className="absolute top-4 left-4 bg-red-500 px-3 py-1 text-xs rounded text-white">
          Used ❌
        </div>

        <div className="absolute top-4 right-4 bg-green-500 px-3 py-1 text-xs rounded text-white">
          LappyShop Refurbished ✅
        </div> */}

      </div>
    </div>
  );
};

export default CompareSlider;